import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import blogReducer from './slices/blog';
import userReducer from './slices/user';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import clientReducer from './slices/client';
import vendorReducer from './slices/vendor';
import projectReducer from './slices/project';
import headerReducer from './slices/header';
import fileManagementReducer from './slices/masterfile';
import filecategoryReducer from './slices/filecategory';
import exclusionrulesReducer from './slices/exclusionrules';
import columnmapReducer from './slices/columnmap';
import scoringReducer from './slices/scoring';
import collectionReducer from './slices/collection';
import usersReducer from './slices/users__';
import userroleReducer from './slices/user_role';
import campaignrulesReducer from './slices/campaignrules';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  blog: blogReducer,
  user: userReducer,
  client: clientReducer,
  vendor: vendorReducer,
  project: projectReducer,
  header: headerReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  filemanager: fileManagementReducer,
  filecategory: filecategoryReducer,
  exclusionrules: exclusionrulesReducer,
  columnmap: columnmapReducer,
  scoring: scoringReducer,
  collection: collectionReducer,
  users__: usersReducer,
  user_role: userroleReducer,
  campaignrules: campaignrulesReducer
});

export { rootPersistConfig, rootReducer };
